import { gql, TypedDocumentNode } from "@apollo/client";

import {
  SearchCustomersQuery,
  SearchCustomersQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { SearchParams } from "src/graphql/anti-fraud/queries/typings.ts";
import { useFetchQuery } from "src/graphql/utils";
import { mapToCustomerSummary } from "src/mappers/customer.mappers";
import { isEmpty } from "src/utils/arrays.utils.ts";

import { customerSummaryFragment } from "../../fragments/CustomerSummaryFragment";

export const searchCustomersQuery = gql`
  query SearchCustomers($searchString: String, $offset: Int = 0, $limit: Int!) {
    customerSearch(
      input: { searchString: $searchString, pagination: { offset: $offset, limit: $limit } }
    ) {
      customers {
        ...CustomerSummaryFragment
      }
      pageInfo {
        totalCount
        offset
        limit
      }
    }
  }
  ${customerSummaryFragment}
` as TypedDocumentNode<SearchCustomersQuery, SearchCustomersQueryVariables>;

// Defines a search query hook for cases
// To be used in a useSearch hook
export const useSearchCustomersQuery = ({ searchTerm, offset, limit }: SearchParams) => {
  // if searchString is empty, send undefined to the query
  return useFetchQuery(searchCustomersQuery, {
    queryOptions: {
      variables: {
        searchString: searchTerm && searchTerm?.length > 0 ? searchTerm : null,
        offset,
        limit,
      },
      fetchPolicy: "network-only",
    },
    toData: (data) =>
      data?.customerSearch && {
        customers: data.customerSearch.customers.map(mapToCustomerSummary),
        pageInfo: data.customerSearch.pageInfo,
      },
    isEmpty: (data) => isEmpty(data?.customerSearch.customers),
    uiErrors: {
      fetchError: "FETCH-CUSTOMERS-ERROR",
    },
  });
};
